var windowWidth;

$(function () {
  windowWidth = $(window).width();

  $(window).on('resize', function () {
    if ($(window).width() != windowWidth) {
      windowWidth = $(window).width();
      closeMenu();
    }
  });

  $(window).on('resize scroll', function () {
    fixedNav();
  });
  fixedNav();
});

function fixedNav() {
  if ($(window).scrollTop() > app.startScrollNav) {
    $('body').addClass('fixed-nav');
    $('.nav-bar__container .nav-bar__item').attr('tabindex', -1);
    return;
  }

  $('body').removeClass('fixed-nav');
  $('.nav-bar__container .nav-bar__item').removeAttr('tabindex');
}
